import { BaseApiService } from '@kinet-open-network/client/core/api-client';
import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import { RawPermissions } from '@kinet-open-network/shared/data-access/model';
import { map } from 'rxjs';

export abstract class BaseAuthApiService<
  T extends BaseModel,
> extends BaseApiService<T> {
  loadPermissions(id: T['id']) {
    return this.http
      .get<{ data: RawPermissions }>(`${this.endpoint}/${id}/permissions`)
      .pipe(map((response) => response.data));
  }

  updatePermissions(id: T['id'], permissions: RawPermissions) {
    return this.http
      .put<{
        data: RawPermissions;
      }>(`${this.endpoint}/${id}/permissions`, permissions)
      .pipe(map((response) => response.data));
  }
}
